import { globalEntitlements } from '../utils/globalEntitlements';

/** @typedef {import('../types').ProductLandingConfig} ProductLandingConfig */

/** @type {ProductLandingConfig} */
export const IPOSTAL1_CONFIG = {
  hero: {
    buyBox: [
      {
        bulletPoints: [
          { title: 'productPage.iPostal1.buyBox.bulletPoint1' },
          { title: 'productPage.iPostal1.buyBox.bulletPoint2' },
          { title: 'productPage.iPostal1.buyBox.bulletPoint3' },
        ],
        productName: 'productPage.iPostal1.buyBox.productName',
        interactService: {
          ctaType: 'externalCheckout',
          service: 'ipostal1',
          openInNewTab: true,
        },
        note: 'productPage.iPostal1.buyBox.note',
      },
    ],
    headerPicture: {
      src: '/s2/raster/focused-laptop-professional.png',
      alt: 'productPage.iPostal1.heroPicture.altText',
    },
    headline: 'productPage.iPostal1.page.headline',
    partnerLogo: {},
    partnerReviewBlanks: [],
    subheader: 'productPage.iPostal1.page.subheader',
  },
  benefit: {
    title: 'productPage.iPostal1.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/lockrounded.svg',
        title: 'productPage.iPostal1.valueProp.propTitle1',
        description: 'productPage.iPostal1.valueProp.shortCopy1',
      },
      {
        icon: '/s2/material-icons/workspacepremiumrounded.svg',
        title: 'productPage.iPostal1.valueProp.propTitle2',
        description: 'productPage.iPostal1.valueProp.shortCopy2',
      },
      {
        icon: '/s2/material-icons/mobilefriendlyrounded.svg',
        title: 'productPage.iPostal1.valueProp.propTitle3',
        description: 'productPage.iPostal1.valueProp.shortCopy3',
      },
    ],
  },
  howItWorks: {
    title: 'productPage.iPostal1.howItWorks.title',
    items: [
      {
        title: 'productPage.iPostal1.howItWorks.step1',
        description: 'productPage.iPostal1.howItWorks.shortDescription1',
      },
      {
        title: 'productPage.iPostal1.howItWorks.step2',
        description: 'productPage.iPostal1.howItWorks.shortDescription2',
      },
      {
        title: 'productPage.iPostal1.howItWorks.step3',
        description: 'productPage.iPostal1.howItWorks.shortDescription3',
      },
      {
        title: 'productPage.iPostal1.howItWorks.step4',
        description: 'productPage.iPostal1.howItWorks.shortDescription4',
      },
    ],
    image: '/s2/raster/woman-using-laptop-home-office.png',
    alt: 'productPage.iPostal1.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true,
  },
  whatsIncluded: {
    title: 'productPage.iPostal1.whatsIncluded.title',
    items: [
      {
        title: 'productPage.iPostal1.whatsIncluded.item1',
        description: 'productPage.iPostal1.whatsIncluded.item1ShortDescription',
      },
      {
        title: 'productPage.iPostal1.whatsIncluded.item2',
        description: 'productPage.iPostal1.whatsIncluded.item2ShortDescription',
      },
      {
        title: 'productPage.iPostal1.whatsIncluded.item3',
        description: 'productPage.iPostal1.whatsIncluded.item3ShortDescription',
      },
    ],
    image: '/s2/raster/phone-desk-office.png',
    alt: 'productPage.iPostal1.whatsIncluded.altText',
    hasDivider: true,
    hasNumber: false,
    hasMobileImage: false,
  },
  faqs: {
    title: 'productPage.iPostal1.frequentlyAskedQuestions.title',
    items: [
      {
        question: 'productPage.iPostal1.frequentlyAskedQuestions.faq1',
        answer: 'productPage.iPostal1.frequentlyAskedQuestions.faqAnswer1',
      },
      {
        question: 'productPage.iPostal1.frequentlyAskedQuestions.faq2',
        answer: 'productPage.iPostal1.frequentlyAskedQuestions.faqAnswer2',
      },
      {
        question: 'productPage.iPostal1.frequentlyAskedQuestions.faq3',
        answer: 'productPage.iPostal1.frequentlyAskedQuestions.faqAnswer3',
      },
    ],
  },
  footnotes: {
    divider: true,
    items: [
      {
        text: 'productPage.iPostal1.footnotes.1.text',
      },
      {
        text: 'productPage.iPostal1.footnotes.2.text',
      },
    ],
  },
  assistance: {
    title: 'productPage.iPostal1.needAssistance.title',
    getInTouch: 'productPage.iPostal1.needAssistance.getInTouch',
    actions: 'productPage.iPostal1.needAssistance.actions',
  },
  getBuyButtonConfig: globalEntitlements({
    ctaText: 'productPage.iPostal1.buyBox.buttonLabel',
  })
    .allowMultiplePurchases()
    .build(),
};
